window.addEventListener('SITE_START', () => {
  const tabContainer = document.querySelector('.lnb__tabs');

  if (!tabContainer) return;

  const tabs = tabContainer.querySelector('.lnb__tab-list');

  const updateDim = () => {
    const { scrollLeft, scrollWidth, clientWidth } = tabs;
    tabContainer.classList.toggle('has-left', scrollLeft > 0);
    tabContainer.classList.toggle('has-right', scrollLeft + clientWidth < scrollWidth);
  };

  updateDim();
  tabs.addEventListener('scroll', updateDim);
  window.addEventListener('resize', updateDim);

  /**
   * 드래그 스크롤 기능
   */
  let isDown = false;
  let startX;
  let scrollLeftStart;
  let hasMoved = false;

  tabs.addEventListener('mousedown', (e) => {
    isDown = true;
    hasMoved = false;
    tabs.style.cursor = 'grabbing';
    tabs.style.userSelect = 'none';
    startX = e.pageX - tabs.offsetLeft;
    scrollLeftStart = tabs.scrollLeft;
  });

  tabs.addEventListener('mouseleave', () => {
    isDown = false;
    tabs.style.cursor = 'grab';
    tabs.style.userSelect = '';
  });

  tabs.addEventListener('mouseup', () => {
    isDown = false;
    tabs.style.cursor = 'grab';
    tabs.style.userSelect = '';
  });

  tabs.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - tabs.offsetLeft;
    const walk = (x - startX) * 1.5; // 스크롤 속도 조절

    if (Math.abs(walk) > 5) {
      hasMoved = true;
    }

    tabs.scrollLeft = scrollLeftStart - walk;
  });

  // 링크 클릭 방지 (드래그한 경우)
  tabs.addEventListener(
    'click',
    (e) => {
      if (hasMoved && e.target.closest('a')) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // 스크롤 가능한 경우 커서 변경
  const updateCursor = () => {
    if (tabs.scrollWidth > tabs.clientWidth) {
      tabs.style.cursor = 'grab';
    } else {
      tabs.style.cursor = 'default';
    }
  };

  updateCursor();
  window.addEventListener('resize', updateCursor);

  // 활성 탭 좌측으로 포커싱 정렬
  // const isMobile = () => window.innerWidth <= 768;
  const padLeft = () => parseFloat(getComputedStyle(tabs).paddingLeft) || 0;

  const activeTabScroll = () => {
    // if (!isMobile()) return;
    if (tabs.scrollWidth <= tabs.clientWidth) return;

    const active = tabs.querySelector('.is-active, .--active, [aria-selected="true"], [aria-current="page"]');
    if (!active) return;

    let left = active.offsetLeft - padLeft(); // 간단/빠름
    left = Math.max(0, Math.min(left, tabs.scrollWidth - tabs.clientWidth));

    tabs.scrollTo({
      left,
      behavior: 'auto',
    });
  };

  // 초기, 리사이즈
  requestAnimationFrame(() => activeTabScroll());
  window.addEventListener('resize', () => activeTabScroll());
});
